import { Chip } from '@mui/material'
import { useFormikContext } from 'formik'
import React, { useEffect } from 'react'

export const getColor = status => {
  if (status === 'rejected') {
    return 'error'
  } else if (status === 'approved') {
    return 'success'
  } else if (status === 'pending') {
    return 'info'
  } else if (status === 'queued') {
    return 'warning'
  } else if (status === 'complete') {
    return 'success'
  } else if (status === 'error') {
    return 'error'
  } else if (status === 'Abnormal Request') {
    return 'error'
  } else if (status === 'not-required') {
    return 'warning'
  } else {
    return 'secondary'
  }
}

function ResponseDetailsComponentNew ({ item }) {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue
  } = useFormikContext()
  useEffect(() => {
    if (item) {
      setFieldValue('outcome', item?.outcome || '')
      setFieldValue('disposition', item?.disposition || '')
    }
  }, [item, setFieldValue])
  function formatDateTime (data) {
    const date = new Date(data)
    // Get date components
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0') // Adding padding if needed
    const day = String(date.getDate()).padStart(2, '0') // Adding padding if needed

    // Get time components
    const hours = String(date.getHours()).padStart(2, '0') // Adding padding if needed
    const minutes = String(date.getMinutes()).padStart(2, '0') // Adding padding if needed
    const seconds = String(date.getSeconds()).padStart(2, '0') // Adding padding if needed

    // Construct the date and time string in the format "YYYY-MM-DD HH:MM:SS"
    const dateTimeString = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`

    return dateTimeString
  }

  return (
    <div class='eligibility_details_section'>
      <div class='eligibility_details_body_cont !grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 !p-0 !border-none !shadow-none'>
        <div class='eligibility_details_user_data   px-1.5 py-1.5'>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Beneficiary Name
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary '>
              {item?.patient_name || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data   px-1.5 py-1.5'>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>Document</span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary '>
              {item?.patient_document_id || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data   px-1.5 py-1.5'>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>Insurer</span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.payer_name || '___'}
            </span>
          </div>
        </div>

        <div class='eligibility_details_user_data  px-1.5 py-1.5'>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>TPA Name</span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.tpa_name || '___'}
            </span>
          </div>
        </div>

        <div class='eligibility_details_user_data  px-1.5 py-1.5'>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>Is Referral</span>
          </div>
          <div class='data_cont !text-left'>
            <label class='switch'>
              <input
                type='checkbox'
                checked={item?.is_referral || false}
                disabled
              />
              <span class='slider'></span>
            </label>
          </div>
        </div>
        <div class='eligibility_details_user_data  px-1.5 py-1.5'>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Eligibility Response Identifier (Value)
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.verification_resp_ident_value || '___'}
            </span>
          </div>
        </div>

        <div class='eligibility_details_user_data  px-1.5 py-1.5'>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Eligibility Response Identifier (Url)
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.verification_resp_ident_url || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data  px-1.5 py-1.5'>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>Is New Born ?</span>
          </div>
          <div class='data_cont !text-left'>
            <label class='switch'>
              <input
                type='checkbox'
                checked={item?.is_new_born || false}
                disabled
              />
              <span class='slider'></span>
            </label>
          </div>
        </div>
        <div class='eligibility_details_user_data  px-1.5 py-1.5'>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Transaction Date
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {formatDateTime(item?.transaction_date) || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data  px-1.5 py-1.5'>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>Date Ordered</span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {formatDateTime(item?.date_ordered) || '___'}
            </span>
          </div>
        </div>

        <div class='eligibility_details_user_data  px-1.5 py-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>Type</span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.type || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data  px-1.5 py-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>Sub Type</span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.subtype || '___'}
            </span>
          </div>
        </div>

        <div class='eligibility_details_user_data  px-1.5 py-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Pre Auth Ref. No.
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.pre_auth_ref_no || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data  px-1.5 py-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Pre Auth Res. Identifier
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.pre_auth_ref_value || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data  px-1.5 py-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Pre Auth Res. Url
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.pre_auth_ref_url || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data  px-1.5 py-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Pre Auth Period
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.pre_auth_period || '___'}
            </span>
          </div>
        </div>

        <div class='eligibility_details_user_data  px-1.5 py-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Related Pre Auth Request Identifier
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.related_pre_auth_req_identifier || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data  px-1.5 py-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Offline Eligibility Id
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.offline_verification_id || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data  px-1.5 py-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Offline Eligibility Date
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.offline_verification_date || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data  px-1.5 py-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>Disposition</span>
          </div>
          <div class='data_cont !text-left'>
            <input
              placeholder='Enter Disposition'
              type='text'
              name='disposition'
              className='block rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:!ring-primary sm:text-sm sm:leading-6'
              value={values?.disposition}
              onChange={handleChange}
              onBlur={handleBlur}
              id='disposition'
            />
          </div>
        </div>

        <div class='eligibility_details_user_data   px-1.5 pt-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Cancellation Status
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.calcellation_status || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data   px-1.5 pt-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Cancellation Status Reason
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.calcellation_status_reason || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data px-1.5 pt-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Related Pre Auth Ref. No.
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.related_pre_auth_ref_no || '___'}
            </span>
          </div>
        </div>

        <div class='eligibility_details_user_data px-1.5 pt-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>Is Follow Up</span>
          </div>
          <div class='data_cont !text-left'>
            <label class='switch'>
              <input
                type='checkbox'
                checked={item?.is_followup_req || false}
                disabled
              />
              <span class='slider'></span>
            </label>
          </div>
        </div>

        <div class='eligibility_details_user_data px-1.5 pt-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>
              Ref Transaction ID{' '}
            </span>
          </div>
          <div class='data_cont !text-left'>
            <span class='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.followup_ref_transaction_id || '___'}
            </span>
          </div>
        </div>
        <div class='eligibility_details_user_data  px-1.5 py-1.5'>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>Outcome</span>
          </div>
          <div class=' !text-left'>
            <select
              className='
              block  rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:!ring-primary sm:text-sm sm:leading-6'
              name='outcome'
              value={values?.outcome}
              onChange={handleChange}
              id='outcome'
            >
              <option value=''>Select Outcome</option>
              <option value='complete'>Complete</option>
              <option value='rejected'>Rejected</option>
              <option value='queued'>Queued</option>
            </select>
          </div>
        </div>
        <div class='eligibility_details_user_data  px-1.5 py-1.5 '>
          <div class='data_head !text-left !mb-0'>
            <span className='!text-gray-700  !text-[15px]'>Status</span>
          </div>
          <div class=' !text-left'>
            <p class=' !text-base !text-[15px] !font-[600] !text-primary'>
              {item?.status ? (
                <Chip
                  label={item?.status}
                  color={getColor(item?.status)}
                  size='small'
                  className='uppercase text-xs !text-white'
                />
              ) : (
                '___'
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResponseDetailsComponentNew
